import { useState } from 'react';
import {
    Col, Row, Container,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import BlockUISpinner from '../../components/BlockUISpinner';

import useHtmlTitle from '../../components/Utilities/useHtmlTitle';
import useBodyClass from '../../components/Utilities/useBodyClass';
import StandardPathway from '../../components/tiles/StandardPathway';
import CustomBreadcrumb, { CustomBreadcrumbItem } from '../../components/Breadcrumb';

const ServicesWeOffer = () => {
    const [isLoading, setIsLoading] = useState(false);

    const breadcrumbs: CustomBreadcrumbItem[] = [
        { to: '/', text: 'Dashboard' },
        { to: '', text: 'Services we offer' },
    ];

    useHtmlTitle('Services we offer | NMI Services portal');
    useBodyClass('services-we-offer');

    return (
        <>
            {isLoading && (
                <BlockUISpinner>
                    <p>Loading...</p>
                </BlockUISpinner>
            )}
            <div aria-busy={isLoading} aria-live='polite' aria-atomic='true'>
                <Container fluid className='default-banner-background mb-5'>
                    <Container>
                        <Row>
                            <Col>
                                <CustomBreadcrumb breadcrumbs={breadcrumbs} />
                            </Col>
                        </Row>
                        <Row className='gs-wrapper'>
                            <Col md={12} lg={9}>
                                <h1 id='page-title' tabIndex={-1} className='banner-title mb-2'>Services we offer</h1>
                            </Col>
                        </Row>
                    </Container>
                </Container>
                <Container>
                    <h2 className='visually-hidden'>Please choose from the following services:</h2>
                    <Row className='mb-2'>
                        <Col>
                            <h2>Physical measurement services</h2>
                        </Col>
                    </Row>
                    <Row className='mb-5'>
                        <Col md={4}>
                            <StandardPathway
                                type='internal'
                                title='Testing and calibration'
                                linkDescription='Request new quote'
                                bodyText='Request an obligation-free quote to test or calibrate your instrument or artefact'
                                to='/request-for-quote-create'
                            />
                        </Col>
                        <Col md={4} />
                        <Col md={4} />
                    </Row>
                    {/* Placeholder for future NMI service offers
                <Row className='mb-3'>
                    <Col>
                        <h2>Trade measurement</h2>
                    </Col>
                </Row>
                <Row className='mb-3'>
                    <Col>
                        <h2>Pattern approval</h2>
                    </Col>
                </Row>
                <Row className='mb-3'>
                    <Col>
                        <h2>Chemical and biological measurement services</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Testing and analytical services</h2>
                    </Col>
                </Row> */}
                    <Row className='mt-4'>
                        <Col>
                            <Link
                                data-testid='go-to-dashboard-button'
                                to='/dashboard'
                                className='btn btn-tertiary'
                            >
                                <i className='icon-close me-1' aria-hidden='true' />
                                Cancel
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default ServicesWeOffer;
